import type { RoutesTreeItem } from 'containers/App/Routes/RoutesTreeItem';
import { changesSummaryRoutes } from 'pages/Management/Changes/ChangesSummary';
import { createTableApiScopeRequirement } from 'utils/rbac/helpers/createTableApiScopeRequirement';

import { NotFoundPage } from 'pages/NotFoundPage/NotFoundPage';
import { ChangesPage } from './Changes/ChangesPage';
import { ConfigurationPage } from './Configuration/ConfigurationPage';
import { ConnectivityErrorsPage } from './Configuration/ConnectivityErrorsPage';
import {
  DiscoveryHistoryPage,
  discoveryHistoryApiEndpoint,
} from './DiscoveryHistory/DiscoveryHistory';
import {
  SavedConfigConsistencyPage,
  savedConfigConsistencyApiEndpoint,
} from './SavedConfigConsistency/SavedConfigConsistencyPage';

export const managementRoutes: RoutesTreeItem[] = [
  {
    path: '/management/changes',
    element: <ChangesPage />,
    children: changesSummaryRoutes,
    requiredApiScope: {
      and: [
        createTableApiScopeRequirement('/tables/management/discovery-runs'),
        {
          or: [
            createTableApiScopeRequirement(
              '/tables/management/changes/connectivity',
            ),
            createTableApiScopeRequirement(
              '/tables/management/changes/devices',
            ),
            createTableApiScopeRequirement('/tables/management/changes/pn'),
            createTableApiScopeRequirement(
              '/tables/management/changes/managed-devs',
            ),
          ],
        },
      ],
    },
  },
  {
    path: '/management/configuration',
    element: <ConfigurationPage />,
    requiredApiScope: createTableApiScopeRequirement(
      '/tables/management/configuration',
    ),
  },
  {
    path: '/management/configuration/connectivity-errors',
    element: <ConnectivityErrorsPage />,
    apiEndpoint: '/tables/management/connectivity-errors',
    requiredApiScope: createTableApiScopeRequirement(
      '/tables/management/connectivity-errors',
    ),
  },
  {
    path: '/management/discovery-history',
    element: <DiscoveryHistoryPage />,
    apiEndpoint: discoveryHistoryApiEndpoint,
    requiredApiScope: createTableApiScopeRequirement(
      discoveryHistoryApiEndpoint,
    ),
  },
  {
    path: '/management/saved-config-consistency',
    element: <SavedConfigConsistencyPage />,
    apiEndpoint: savedConfigConsistencyApiEndpoint,
    requiredApiScope: createTableApiScopeRequirement(
      savedConfigConsistencyApiEndpoint,
    ),
    requiredSnapshot: true,
  },
  {
    path: '/management/:notfound',
    element: <NotFoundPage />,
  },
];
